// Mount-guard helpers for the universal workflow screens (summary, payment, acceptance,
// confirmation, end). ALWAYS derive these checks from the configured product order — a
// hardcoded per-product list silently bounces every product added later (this bit both
// doorlopendereis and ongevallen on their introduction).
import { getProductOrder } from '../workflowConfig';

type Selection = Record<string, boolean | undefined> | null | undefined;

/** At least one product is selected — generic over whatever products exist. */
export const hasAnySelectedProduct = (selectedProducts: Selection): boolean =>
  Object.values(selectedProducts || {}).some((v) => v === true);

/** Route of the first selected product in the configured order; null when none. */
export const firstSelectedProductRoute = (selectedProducts: Selection): string | null => {
  const first = getProductOrder().find((id) => selectedProducts?.[id]);
  return first ? `/workflow/${first}` : null;
};

/** Any selected product has produced a Contractdocument (i.e. has been configured). */
export const hasAnyProductDocument = (
  selectedProducts: Selection,
  getData: (id: string) => any,
): boolean => getProductOrder().some((id) => selectedProducts?.[id] && getData(id)?.Contractdocument);
